import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { DEFAULT_PREFS, applyPrefsToDocument, persistPrefs, readStoredPrefs } from "./accessibilityPrefs";

const AccessibilityContext = createContext(null);

export const AccessibilityProvider = ({ children }) => {
  const [prefs, setPrefs] = useState(() => readStoredPrefs());

  useEffect(() => {
    // Reconcile in case the inline pre-hydration script (index.html) and
    // this initial state ever disagree — keeps <html> classes authoritative.
    applyPrefsToDocument(prefs);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const setPref = useCallback((key, value) => {
    setPrefs((prev) => {
      const next = { ...prev, [key]: value };
      persistPrefs(next);
      return next;
    });
  }, []);

  const resetPrefs = useCallback(() => {
    const next = { ...DEFAULT_PREFS };
    setPrefs(next);
    persistPrefs(next);
  }, []);

  return (
    <AccessibilityContext.Provider value={{ prefs, setPref, resetPrefs }}>
      {children}
    </AccessibilityContext.Provider>
  );
};

export const useAccessibilityPrefs = () => {
  const ctx = useContext(AccessibilityContext);
  if (!ctx) {
    throw new Error("useAccessibilityPrefs must be used within an AccessibilityProvider");
  }
  return ctx;
};
